import { StaticImage } from 'gatsby-plugin-image';
import React, { useRef } from 'react';
import styled from 'styled-components';
import { Marquee } from '@/features/new-landing-page/components/marquee';

export function CustomersScroller({ className }: { className?: string }) {
  const firstLineRef = useRef<HTMLDivElement>(null);

  return (
    <Wrapper className={className}>
      <TwoLines>
        <LineOne className="only-desktop" ref={firstLineRef}>
          <AllLogos />
        </LineOne>
      </TwoLines>
      <Marquee className="marquee only-mobile" gap="4rem" duration={84}>
        <AllLogos />
      </Marquee>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  padding: 2rem 0;

  && > .marquee > .gatsby-image-wrapper.only-mobile {
    transform: scale(1.1);
  }
`;

const TwoLines = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5rem;
`;

const LineOne = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 120rem;

  column-gap: 3rem;
  row-gap: 4rem;
  justify-content: center;
  margin: 0 auto;

  && > .gatsby-image-wrapper {
    transform: scale(0.95);
  }

  && .only-desktop:nth-of-type(2n):nth-of-type(2n + 32) {
    display: none;
  }
`;

export function AllLogos() {
  return (
    <>
      <StaticImage
        className="only-mobile"
        src="fct.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={182}
        objectFit="contain"
      />
      <StaticImage
        className="only-desktop"
        src="fct.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={200}
        objectFit="contain"
      />

      <StaticImage
        className="only-mobile"
        src="faherty.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={70}
        objectFit="contain"
      />
      <StaticImage
        className="only-desktop"
        src="faherty.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={80}
        objectFit="contain"
      />

      {/* <StaticImage */}
      {/*  className="only-mobile" */}
      {/*  src="laneige.png" */}
      {/*  alt="" */}
      {/*  placeholder="none" */}
      {/*  loading="eager" */}
      {/*  width={80} */}
      {/*  objectFit="contain" */}
      {/* /> */}
      {/* <StaticImage */}
      {/*  className="only-desktop" */}
      {/*  src="laneige.png" */}
      {/*  alt="" */}
      {/*  placeholder="none" */}
      {/*  loading="eager" */}
      {/*  width={88} */}
      {/*  objectFit="contain" */}
      {/* /> */}

      <StaticImage
        className="only-mobile"
        src="merit.webp"
        alt=""
        placeholder="none"
        loading="eager"
        width={120}
        objectFit="contain"
      />
      <StaticImage
        className="only-desktop"
        src="merit.webp"
        alt=""
        placeholder="none"
        loading="eager"
        width={110}
        objectFit="contain"
      />

      <StaticImage
        className="only-mobile"
        src="truewerk.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={95}
        objectFit="contain"
      />
      <StaticImage
        className="only-desktop"
        src="truewerk.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={100}
        objectFit="contain"
      />

      <StaticImage
        className="only-mobile"
        src="bonafide.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={95}
        objectFit="contain"
      />
      <StaticImage
        className="only-desktop"
        src="bonafide.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={110}
        objectFit="contain"
      />

      <StaticImage
        className="only-mobile"
        src="moroccanoil.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={125}
        objectFit="contain"
      />
      <StaticImage
        className="only-desktop"
        src="moroccanoil.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={154}
        objectFit="contain"
      />

      <StaticImage
        className="only-mobile"
        src="beis.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={50}
        objectFit="contain"
      />
      <StaticImage
        className="only-desktop"
        src="beis.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={60}
        objectFit="contain"
      />

      <StaticImage
        className="only-mobile"
        src="sketchers.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={110}
        objectFit="contain"
      />
      <StaticImage
        className="only-desktop"
        src="sketchers.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={130}
        objectFit="contain"
      />

      <StaticImage
        className="only-mobile"
        src="laurageller.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={70}
        objectFit="contain"
      />
      <StaticImage
        className="only-desktop"
        src="laurageller.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={90}
        objectFit="contain"
      />

      <StaticImage
        className="only-mobile"
        src="jdsports.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={40}
        objectFit="contain"
      />
      <StaticImage
        className="only-desktop"
        src="jdsports.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={50}
        objectFit="contain"
      />

      <StaticImage
        className="only-mobile"
        src="pata.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={100}
        objectFit="contain"
      />
      <StaticImage
        className="only-desktop"
        src="pata.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={150}
        objectFit="contain"
      />

      <StaticImage
        className="only-mobile"
        src="underoutfit.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={130}
        objectFit="contain"
      />
      <StaticImage
        className="only-desktop"
        src="underoutfit.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={180}
        objectFit="contain"
      />

      {/* <StaticImage */}
      {/*  className="only-mobile" */}
      {/*  src="poshpeanut.png" */}
      {/*  alt="" */}
      {/*  placeholder="none" */}
      {/*  loading="eager" */}
      {/*  width={130} */}
      {/*  objectFit="contain" */}
      {/* /> */}
      {/* <StaticImage */}
      {/*  className="only-desktop" */}
      {/*  src="poshpeanut.png" */}
      {/*  alt="" */}
      {/*  placeholder="none" */}
      {/*  loading="eager" */}
      {/*  width={160} */}
      {/*  objectFit="contain" */}
      {/* /> */}

      {/* <StaticImage */}
      {/*  className="only-mobile" */}
      {/*  src="chomps.png" */}
      {/*  alt="" */}
      {/*  placeholder="none" */}
      {/*  loading="eager" */}
      {/*  width={70} */}
      {/*  objectFit="contain" */}
      {/* /> */}
      {/* <StaticImage */}
      {/*  className="only-desktop" */}
      {/*  src="chomps.png" */}
      {/*  alt="" */}
      {/*  placeholder="none" */}
      {/*  loading="eager" */}
      {/*  width={80} */}
      {/*  objectFit="contain" */}
      {/* /> */}

      <StaticImage
        className="only-mobile"
        src="branch.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={80}
        objectFit="contain"
      />
      <StaticImage
        className="only-desktop"
        src="branch.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={90}
        objectFit="contain"
      />

      {/* <StaticImage */}
      {/*  className="only-mobile" */}
      {/*  src="graza.png" */}
      {/*  alt="" */}
      {/*  placeholder="none" */}
      {/*  loading="eager" */}
      {/*  width={65} */}
      {/*  objectFit="contain" */}
      {/* /> */}
      {/* <StaticImage */}
      {/*  className="only-desktop" */}
      {/*  src="graza.png" */}
      {/*  alt="" */}
      {/*  placeholder="none" */}
      {/*  loading="eager" */}
      {/*  width={75} */}
      {/*  objectFit="contain" */}
      {/* /> */}

      {/* <StaticImage */}
      {/*  className="only-mobile" */}
      {/*  src="represent.png" */}
      {/*  alt="" */}
      {/*  placeholder="none" */}
      {/*  loading="eager" */}
      {/*  width={95} */}
      {/*  objectFit="contain" */}
      {/* /> */}
      {/* <StaticImage */}
      {/*  className="only-desktop" */}
      {/*  src="represent.png" */}
      {/*  alt="" */}
      {/*  placeholder="none" */}
      {/*  loading="eager" */}
      {/*  width={100} */}
      {/*  objectFit="contain" */}
      {/* /> */}

      <StaticImage
        className="only-mobile"
        src="misen.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={105}
        objectFit="contain"
      />
      <StaticImage
        className="only-desktop"
        src="misen.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={110}
        objectFit="contain"
      />

      <StaticImage
        className="only-mobile"
        src="orthofeet.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={95}
        objectFit="contain"
      />
      <StaticImage
        className="only-desktop"
        src="orthofeet.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={100}
        objectFit="contain"
      />

      {/* <StaticImage */}
      {/*  className="only-mobile" */}
      {/*  src="blendjet.png" */}
      {/*  alt="" */}
      {/*  placeholder="none" */}
      {/*  loading="eager" */}
      {/*  width={100} */}
      {/*  objectFit="contain" */}
      {/* /> */}
      {/* <StaticImage */}
      {/*  className="only-desktop" */}
      {/*  src="blendjet.png" */}
      {/*  alt="" */}
      {/*  placeholder="none" */}
      {/*  loading="eager" */}
      {/*  width={110} */}
      {/*  objectFit="contain" */}
      {/* /> */}

      <StaticImage
        className="only-mobile"
        src="theoodie.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={80}
        objectFit="contain"
      />
      <StaticImage
        className="only-desktop"
        src="theoodie.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={100}
        objectFit="contain"
      />

      <StaticImage
        className="only-mobile"
        src="andye.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={70}
        objectFit="contain"
      />
      <StaticImage
        className="only-desktop"
        src="andye.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={85}
        objectFit="contain"
      />

      <StaticImage
        className="only-mobile"
        src="dermalogica.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={140}
        objectFit="contain"
      />
      <StaticImage
        className="only-desktop"
        src="dermalogica.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={165}
        objectFit="contain"
      />

      {/* <StaticImage */}
      {/*  className="only-mobile" */}
      {/*  src="benchmade.png" */}
      {/*  alt="" */}
      {/*  placeholder="none" */}
      {/*  loading="eager" */}
      {/*  width={110} */}
      {/*  objectFit="contain" */}
      {/* /> */}
      {/* <StaticImage */}
      {/*  className="only-desktop" */}
      {/*  src="benchmade.png" */}
      {/*  alt="" */}
      {/*  placeholder="none" */}
      {/*  loading="eager" */}
      {/*  width={130} */}
      {/*  objectFit="contain" */}
      {/* /> */}

      <StaticImage
        className="only-mobile"
        src="canopy.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={95}
        objectFit="contain"
      />
      <StaticImage
        className="only-desktop"
        src="canopy.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={100}
        objectFit="contain"
      />

      {/* <StaticImage */}
      {/*  className="only-mobile" */}
      {/*  src="solawave.png" */}
      {/*  alt="" */}
      {/*  placeholder="none" */}
      {/*  loading="eager" */}
      {/*  width={95} */}
      {/*  objectFit="contain" */}
      {/* /> */}
      {/* <StaticImage */}
      {/*  className="only-desktop" */}
      {/*  src="solawave.png" */}
      {/*  alt="" */}
      {/*  placeholder="none" */}
      {/*  loading="eager" */}
      {/*  width={120} */}
      {/*  objectFit="contain" */}
      {/* /> */}

      {/* <StaticImage */}
      {/*  className="only-mobile" */}
      {/*  src="mockingbird.png" */}
      {/*  alt="" */}
      {/*  placeholder="none" */}
      {/*  loading="eager" */}
      {/*  width={120} */}
      {/*  objectFit="contain" */}
      {/* /> */}
      {/* <StaticImage */}
      {/*  className="only-desktop" */}
      {/*  src="mockingbird.png" */}
      {/*  alt="" */}
      {/*  placeholder="none" */}
      {/*  loading="eager" */}
      {/*  width={140} */}
      {/*  objectFit="contain" */}
      {/* /> */}

      {/* <StaticImage */}
      {/*  className="only-mobile" */}
      {/*  src="pvolve.png" */}
      {/*  alt="" */}
      {/*  placeholder="none" */}
      {/*  loading="eager" */}
      {/*  width={80} */}
      {/*  objectFit="contain" */}
      {/* /> */}
      {/* <StaticImage */}
      {/*  className="only-desktop" */}
      {/*  src="pvolve.png" */}
      {/*  alt="" */}
      {/*  placeholder="none" */}
      {/*  loading="eager" */}
      {/*  width={90} */}
      {/*  objectFit="contain" */}
      {/* /> */}

      <StaticImage
        className="only-mobile"
        src="theperfectjean.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={115}
        objectFit="contain"
      />
      <StaticImage
        className="only-desktop"
        src="theperfectjean.png"
        alt=""
        placeholder="none"
        loading="eager"
        width={140}
        objectFit="contain"
      />
    </>
  );
}
